/* Matrix Luxury Living: display-only comma-free AUD prices.
   Never changes product data, checkout totals, or numerical calculations. */
(() => {
  'use strict';
  const priceSelector = '.price, .price__item, .price-item, .product-price, .money, .product-card__price, .cart-item__price, .cart-drawer__price, .cart__price, .cart__total, .totals__subtotal-value, [data-section-ref="price"]';
  const thousandComma = /(\d),(?=\d{3}(?:\D|$))/g;
  function cleanText(textNode) {
    const str = textNode.nodeValue;
    if (!str || str.indexOf(',') < 0 || !/\d,\d{3}/.test(str)) return;
    const next = str.replace(thousandComma, '$1');
    if (next !== str) textNode.nodeValue = next;
  }
  function cleanPriceContainer(el) {
    if (!el || !el.ownerDocument) return;
    const walker = el.ownerDocument.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) cleanText(walker.currentNode);
  }
  function apply(root) {
    if (!root) return;
    if (root.nodeType === Node.TEXT_NODE) {
      const parent = root.parentElement;
      if (parent && parent.closest(priceSelector)) cleanText(root);
      return;
    }
    if (root.nodeType !== Node.ELEMENT_NODE) return;
    if (root.matches(priceSelector)) {
      cleanPriceContainer(root);
    } else {
      if (root.closest(priceSelector)) cleanPriceContainer(root);
      root.querySelectorAll(priceSelector).forEach(cleanPriceContainer);
    }
  }
  const queue = new Set();
  let raf = 0;
  function flush() {
    raf = 0;
    for (const node of queue) apply(node);
    queue.clear();
  }
  function start() {
    if (!document.body) return;
    apply(document.body);
    const observer = new MutationObserver(mutations => {
      for (const change of mutations) {
        if (change.type === 'characterData') queue.add(change.target);
        for (const node of change.addedNodes || []) queue.add(node);
      }
      if (!raf && queue.size) raf = requestAnimationFrame(flush);
    });
    observer.observe(document.body, {subtree:true,childList:true,characterData:true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();